import CONFIG from '../config';

export const SELECTORS = ', .pt_content #primary ';
export const UBISOFT_PLUS_SUBSCRIPTION_ID = '5c12949ad9d14601d43eea96';

//Style constants
export const UBISOFT_BLUE = '#428ee0'
export const UBISOFT_FONT = '\'Ubisoft Sans Regular\',arial,sans-serif'
export const UBISOFT_BOLD_FONT = '\'Ubisoft Sans Bold\',arial,sans-serif;'
export const UBUNTU_FONT = '\'Ubuntu\',\'Ubisoft Sans Regular\',sans-serif;'
export const CURRENT_FONT = !CONFIG.isUPC ?  UBISOFT_FONT : UBUNTU_FONT;

//Navigation specific breakpoints
export const NAVIGATION_TABLET_MODE= "1280px";
export const NAVIGATION_MOBILE_MODE = "820px";

export const TABLET_BREAKPOINT = '1280px';
export const MIN_PRICE_BANNER_SIZE = '850px';
export const PRICE_BANNER_MOBILE = '425px';
export const MIN_TABLET_BREAKPOINT = '750px';
export const MOBILE_BREAKPOINT = '720px';
export const MOBILE_SLIDER_BREAKPOINT = '600px'
